import axiosClient from "../axiosClient";
import streamingClient from "../streamingClient";

export const cameraManagement = {

  update: (data, code) => {
    return axiosClient.put(
      `/cameraManagement/put-change-info-camera/?camera_code=${code}`,
      data,'camera_name'
    );
  },
  reName:(data,code)=>{
    return axiosClient.put(
      `/cameraManagement/put-change-info-camera/?camera_code=${code}`,
      data
    );
  },
  startStreaming: (url, data) => {
    return streamingClient.post(url, data);
  },
  stopStreaming: (data) => {
    return streamingClient.post("streamManagement/post-stop-streaming/", data);
  },
  add: (url, data) => {
    return axiosClient.post(`${url}`, data);
  },
  delete: (code) => {
    return axiosClient.delete(
      `/cameraManagement/delete-remove-camera/?camera_code=${code}`
    );
  },
  restartStream: (data) => {
    return streamingClient.post(
      "/streamManagement/post-restart-streaming/",
      data
    );
  },
  getListPriority: (isGroup) => {
    return axiosClient.get("camerainfo/get-list-camera-priority/", {
      params: {
        type: isGroup ? "group" : "province",
      }
    })
  },
  getList: (params) => {
    return axiosClient.get('cameraManagement/get-list-camera/', {
      params: params
    })
  },
  getOne: (params) => {
    return axiosClient.get('cameraManagement/get-camera-info-by-code/', {
      params: params
    })
  },

  postStatus: (data) => {
    return streamingClient.post("/streamManagement/post-state-list-camera-stream/", data)
  },
  putChangeStatusCamera: (code, data) => {
    return axiosClient.put(`cameraManagement/put-change-status-camera/?camera_code=${code}`, data)
  }
};
